import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../components/atoms/PrimaryButton'
// import { request } from '../../Utils/Request'
// import { apiEndPoint } from '../../Utils/Redux/Store/apiEndpoint'
import carValidationSchemas from './carValidationSchemas'
import '../Registration/registrationStep1.css'
import { useSnackbar } from 'notistack'
import CarRegisterStepFir from './CarRegisterStepFir'
import { CarRegisterStepSec } from './CarRegisterStepSec'
import { AskingPrice } from './AskingPrice'
import { PublishListing } from './PublishListing'
import publishCar from '../../assets/images/publishCar.png'
import CarRegisterRegistrationNumber from './CarRegisterRegistrationNumber'
import CarRegisterCreateAuction from './CarRegisterCreateAuction'
import { PublishAuction } from './PublishAuction'
import { handleRedirectInternal } from '../../common/components'
import { request } from '../../Utils/Request'
import { isAuthenticated } from '../../Utils/Auth'
import JwtDecode from 'jwt-decode'
import { Description } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import CustomModal from '../../components/molecules/CustomModal'

const CarRegister = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const history = useHistory()
    const { search } = useLocation()
    const Location = useLocation()
    const { t } = useTranslation()
    const [currentStep, setCurrentStep] = useState(1)
    const [carInformation, setCarInformation] = useState({
        regNum: '',
        mileage: '',
        rememberMe: false,
    })
    const [user_id] = useState(isAuthenticated() ? JwtDecode(isAuthenticated()).id : 0)
    const [skipOver, setSkipOver] = useState(false)
    const [loader, setLoader] = useState(false)
    const [termsAndCondPopup, setTermsAndCondPopup] = useState(false)

    const [step, setStep] = useState(0)
    const [thirdParty, setThirdData] = useState([])
    const [swissCarDetails, setSwissCarDetails] = useState({})

    const storedCarInfo = JSON.parse(localStorage.getItem('carInfo'))

    const formik = useFormik({
        initialValues: {
            protitle: '',
            regNum: '',
            mileage: '',
            price: '',
            vehicle_interior: [],
            vehicle_exterior: [],
            service_book: [],
            scratches_dents: [],
            keys: '',
            tyres: '',
            year: '',
            month: '',
            leasingValue: '',
            financeValue: '',
            paidOff: '',
            specificDetails: '',
            damageNotes: '',
            carDetails: [],
            // end_date: null,
            // start_date: null,
            // description: '',
            // title: '',
            // city: '',
            // state: '',
            // country: '',
            // zipcode: '',
            // phonenumber: '',
        },
        validationSchema: step == 2 && skipOver ? null : carValidationSchemas()[step],
        onSubmit: (values) => {},
    })

    const nextStep = async () => {
        const errors = await formik.validateForm()
        console.log('error -', formik.errors.regNum)
        formik.setTouched(errors, true)
        if (isAuthenticated()) {
            if (Object.keys(errors).length === 0) {
                setStep(step + 1)
            }
        } else {
            history.push('/login')
        }
    }

    const RegNumCheck = async () => {
        const userDetails = localStorage.getItem('coachUser')
            ? JSON.parse(localStorage.getItem('coachUser'))
            : {}
        if (userDetails.role == 0) {
            history.push('/registration_step_1')
        } else {
            setLoader(true)
            const { data } = await request(
                'get',
                `/carzaar/fetch_car_details?regnr=${formik.values.regNum}`,
                '',
                true,
                0,
            )

            if (data?.success == true) {
                // const res = await request(
                //     'post',
                //     `/check_existing_regnum`,
                //     {
                //         regNum: formik.values.regNum,
                //         site_id: process.env.REACT_APP_SITE_ID,
                //     },
                //     true,
                //     1,
                // )

                // if (res.data?.success == true) {
                console.log('PUKA SucC')
                setLoader(false)
                setSwissCarDetails(data.data)
                const errors = await formik.validateForm()
                formik.setTouched(errors, true)
                formik.setFieldValue('carDetails', data.data.approvalView)
                if (isAuthenticated()) {
                    if (Object.keys(errors).length === 0) {
                        setStep(step + 1)
                    }
                } else {
                    history.push('/login', {
                        ...formik.values,
                        carDetails: data.data.buyerView,
                        step: step + 1,
                    })
                }
                // }
                //  else {
                //     formik.setFieldError('regNum', 'Registration Number is already exists')
                //     setLoader(false)
                // }
            } else {
                formik.setFieldError('regNum', 'Invalid Registration Number')
                setLoader(false)
                // enqueueSnackbar('Please Enter Valid Registration Number!', {
                //     variant: 'error',
                // })
            }
            // if (formik.errors.regNum) {
            //     enqueueSnackbar('Please Enter Valid Registration Number!', {
            //         variant: 'error',
            //     })
            // }
        }
    }

    const publishListing = async (status) => {
        try {
            const errors = await formik.validateForm()
            formik.setTouched(errors, true)

            if (Object.keys(errors).length !== 0) {
                return
            }

            const renameFiles = (files, suffix) => {
                return files.map((file) => {
                    if (file instanceof File) {
                        const ext = file.name.split('.').pop()
                        const name = file.name.replace(`.${ext}`, '')
                        return new File([file], `${name}_${suffix}.${ext}`, { type: file.type })
                    }
                    return file
                })
            }

            const product_image = [
                ...renameFiles(formik.values.vehicle_exterior, 'exterior'),
                ...renameFiles(formik.values.vehicle_interior, 'interior'),
                ...renameFiles(formik.values.service_book, 'servicebook'),
                ...renameFiles(formik.values.scratches_dents, 'dent'),
            ]

            const data = {
                vehicleName: '',
                regNum: formik.values.regNum,
                mileage: formik.values.mileage,
                keys: formik.values.keys,
                tyres: formik.values.tyres,
                year: formik.values.year,
                month: formik.values.month,
                leasingValue: formik.values.leasingValue,
                financeValue: formik.values.financeValue,
                paidOff: formik.values.paidOff,
                specialDetails: formik.values.specificDetails,
                damageNotes: formik.values.damageNotes,
                price: formik.values.price,
                site_id: process.env.REACT_APP_SITE_ID,
                user_id: user_id,
                market_status: status,
                protitle: formik.values.protitle,
                // end_date: formik.values.end_date,
                // start_date: formik.values.start_date,
                // description: formik.values.description,
                // title: formik.values.title,
                // city: formik.values.city,
                // state: formik.values.state,
                // country: formik.values.country,
                // zipcode: formik.values.zipcode,
                // phonenumber: formik.values.phonenumber,
            }

            const formData = new FormData()
            for (const [key, value] of Object.entries(data)) {
                formData.set(key, value)
            }
            console.log('SWISS', swissCarDetails)
            const approalPhaseData = [swissCarDetails.approvalView]
            //Dont change the order in below array
            const buyerPhaseData = [
                swissCarDetails.buyerView,
                swissCarDetails.auctionDetails,
                swissCarDetails.approvalPreview,
                swissCarDetails.previewDetails,
            ]

            //Send the third party details from FE to BE
            formData.append('approalPhaseData', JSON.stringify(approalPhaseData) ?? {})
            formData.append('buyerPhaseData', JSON.stringify(buyerPhaseData) ?? {})
            formData.append(
                'protitle',
                swissCarDetails.previewDetails.makeType +
                    ' ' +
                    swissCarDetails.previewDetails.tradeName,
            )

            product_image.forEach((file, index) => {
                formData.append(`product_image`, file)
            })
            setLoader(true)
            const res = await request('post', '/sellerpostprojectlive_carzaar', formData, true)

            if (res.data.status == 'true') {
                enqueueSnackbar('Listing Posted Successfully', {
                    variant: 'success',
                })
                setLoader(false)
                handleRedirectInternal(history, 'dashboard/seller/mylots')
            } else {
                setLoader(false)
                enqueueSnackbar('Something Went Wrong', {
                    variant: 'error',
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    console.log('third data -', thirdParty)

    const decodeJWT = () => {
        const token = localStorage.getItem('coachToken')

        if (token) {
            const payload = token.split('.')[1]
            const decoded = JSON.parse(atob(payload))

            return decoded
        } else {
            return null
        }
    }

    const termsAndCondAcceptClickHandler = async () => {
        if (!isAuthenticated()) {
        } else {
            const decoded = decodeJWT()
            if (decoded) {
                const userID = decoded?.id

                const body = {
                    site_id: process.env.REACT_APP_SITE_ID,
                    user_id: userID,
                    terms_check: 1,
                }

                axios
                    .put(`${process.env.REACT_APP_MOBILE_API_URL}/update_terms_condition`, body)
                    .then(function (response) {
                        try {
                            if (response.data.success) {
                                localStorage.setItem('termsCheckSeller', 1)
                                publishListing('draft')
                                setTermsAndCondPopup(false)
                            }
                        } catch (e) {
                            console.error('Error while processing API response:', e)
                        }
                    })
                    .catch((error) => {
                        console.error('Error during API call:', error)
                    })
            }
        }
    }

    const publishLive = () => {
        if (isAuthenticated()) {
            const decoded = decodeJWT()
            if (decoded) {
                if (
                    localStorage.getItem('termsCheckSeller') != 1 &&
                    decoded.terms_check == 0 &&
                    decoded.role == 1
                ) {
                    setTermsAndCondPopup(true)
                } else {
                    publishListing('draft')
                }
            } else {
                console.log('ERROR')
            }
        }
    }

    const publishDraft = () => {
        publishListing('moderate')
    }

    useEffect(() => {
        if (storedCarInfo && typeof storedCarInfo !== 'undefined') {
            setCarInformation({
                regNum: storedCarInfo.regNum,
                mileage: storedCarInfo.mileage,
                rememberMe: true,
            })
        }
    }, [])

    useEffect(() => {
        console.log('car Registration-1', Location?.state)
        if (Location?.state) {
            console.log('car Registration-', Location?.state)
            const cardetails1 = Location?.state?.carDetails
            setStep(Location?.state?.step || 0)
            formik.setValues({
                ...formik.values, // Keep existing values
                ...location.state,
                protitle: cardetails1?.makeType,
                carDetails: cardetails1,
            })
        }
    }, [Location?.state])

    console.log('formik values-', formik.values)
    return (
        <div className="mobile-signup row m-0">
            <div className="col-lg-6 col-12 login-content-area">
                <div className="signup-area-content">
                    <form onSubmit={formik.handleSubmit}>
                        {step == 0 ? (
                            <CarRegisterRegistrationNumber
                                formik={formik}
                                nextStep={RegNumCheck}
                                loader={loader}
                            />
                        ) : step == 1 ? (
                            <CarRegisterStepFir formik={formik} nextStep={nextStep} />
                        ) : step == 2 ? (
                            <CarRegisterStepSec
                                formik={formik}
                                nextStep={nextStep}
                                setSkipOver={setSkipOver}
                                skipOver={skipOver}
                            />
                        ) : step == 3 ? (
                            <AskingPrice formik={formik} nextStep={nextStep} />
                        ) : step == 4 ? (
                            <PublishListing
                                formik={formik}
                                nextStep={nextStep}
                                publishDraft={publishDraft}
                                publishLive={publishLive}
                                loader={loader}
                            />
                        ) : (
                            <CarRegisterRegistrationNumber
                                formik={formik}
                                nextStep={RegNumCheck}
                                loader={loader}
                            />
                        )}
                    </form>
                </div>
            </div>
            <div className="col-lg-6 col-12 p-0 borderRight">
                <div
                    className={
                        step == 4 ? 'login-car-image cr' : 'login-car-image change-container'
                    }
                >
                    {step == 4 ? (
                        formik.values.carDetails ? (
                            <div className="car-container">
                                <div className="car-image-contents publish">
                                    <div className="card">
                                        <div className="card-image">
                                            <img
                                                src={formik.values.vehicle_exterior[0]?.preview}
                                                alt="Car"
                                            />
                                        </div>
                                        <div className="card-content">
                                            <div className="card-header">
                                                <h2 className="license">
                                                    {' '}
                                                    {swissCarDetails?.previewDetails?.makeType +
                                                        ' ' +
                                                        swissCarDetails?.previewDetails?.tradeName}
                                                </h2>
                                                {/* <span className="status">DRAFT</span> */}
                                            </div>

                                            <p className="model">{formik.values.protitle}</p>
                                            <p className="description">
                                                {formik.values.carDetails?.tradeName}
                                            </p>

                                            <div className="tags">
                                                {formik.values.regNum && (
                                                    <span>{formik.values.regNum}</span>
                                                )}
                                                {swissCarDetails?.previewDetails?.yearModel && (
                                                    <span>
                                                        {swissCarDetails?.previewDetails?.yearModel}
                                                    </span>
                                                )}
                                                {swissCarDetails?.previewDetails?.fuelType && (
                                                    <span>
                                                        {swissCarDetails?.previewDetails?.fuelType}
                                                    </span>
                                                )}
                                                {swissCarDetails?.previewDetails?.transmission && (
                                                    <span>
                                                        {
                                                            swissCarDetails?.previewDetails
                                                                ?.transmission
                                                        }
                                                    </span>
                                                )}
                                                {swissCarDetails?.previewDetails?.enginePower !=
                                                    '' &&
                                                    swissCarDetails?.previewDetails?.enginePower !=
                                                        0 && (
                                                        <span>
                                                            {isNaN(
                                                                swissCarDetails?.previewDetails
                                                                    ?.enginePower,
                                                            )
                                                                ? 0
                                                                : `${Math.round(
                                                                      swissCarDetails
                                                                          ?.previewDetails
                                                                          ?.enginePower * 1.36,
                                                                  )} ${t('engine_power_value')}`}
                                                        </span>
                                                    )}

                                                {swissCarDetails?.previewDetails?.driveTrain && (
                                                    <span>
                                                        {
                                                            swissCarDetails?.previewDetails
                                                                ?.driveTrain
                                                        }
                                                    </span>
                                                )}
                                                <span>{`${formik.values.mileage} ${t(
                                                    'mileage',
                                                )}`}</span>
                                                {swissCarDetails?.previewDetails?.rackvidd != 0 &&
                                                    swissCarDetails?.previewDetails?.rackvidd !=
                                                        'NA' && (
                                                        <span>
                                                            {`${swissCarDetails?.previewDetails?.rackvidd} KM`}
                                                        </span>
                                                    )}
                                            </div>

                                            <p className="price">{formik.values.price} SEK</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="car-image-contents bottom2 cr">
                                    <h4 className="light-black">{t('quick_easy')}</h4>
                                    <p className="light-black">{t('set_your_car')}</p>
                                </div>
                                <div className="car-image-contents bottom3 cr">
                                    <h4 className="light-black"> {t('do_you_need')}?</h4>
                                    <p className="light-black">
                                        {t('call_sms')}{' '}
                                        <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                                        {t('via_chat')}
                                    </p>
                                </div> */}
                            </div>
                        ) : (
                            <div className="car-container">
                                <div className="car-image-contents publish">
                                    <div className="card">
                                        <div className="card-image">
                                            <img src={publishCar} alt="Car" />
                                        </div>
                                        <div className="card-content">
                                            <div className="card-header">
                                                <h2 className="license">{formik.values.regNum}</h2>
                                                {/* <span className="status">DRAFT</span> */}
                                            </div>

                                            <p className="model">{formik.values.protitle}</p>
                                            <p className="description">
                                                {/* Audi Q2 35 TFSI Manual, 150hp, 2022 */}
                                            </p>

                                            <div className="tags">
                                                <span>{formik.values.year}</span>
                                                <span>{formik.values.mileage} miles</span>
                                                <span>Petrol</span>
                                                <span>Two-wheel drive</span>
                                            </div>

                                            <p className="price">{formik.values.price} SEK</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="car-image-contents bottom2 cr">
                                    <h4 className="light-black">{t('quick_easy')}</h4>
                                    <p className="light-black">{t('set_your_car')}</p>
                                </div>
                                <div className="car-image-contents bottom3 cr">
                                    <h4 className="light-black"> {t('do_you_need')}?</h4>
                                    <p className="light-black">
                                        {t('call_sms')}{' '}
                                        <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                                        {t('via_chat')}
                                    </p>
                                </div> */}
                            </div>
                        )
                    ) : (
                        <div className="car-container">
                            <h4
                                style={{
                                    textAlign: 'left',
                                    color: '#ffffff',
                                    fontWeight: '600',
                                    marginLeft: '15px',
                                    paddingTop: '18px',
                                }}
                            >
                                {t('how_to_sell')}?
                            </h4>
                            <div className="car-image-contents bottom11">
                                <h4 className="light-black">1. {t('upload_car')}</h4>
                                <p className="light-black">{t('fill_your_car')}</p>
                            </div>
                            <div className="car-image-contents bottom12">
                                <h4 className="light-black">2. {t('reservation_price')}</h4>
                                <p className="light-black">{t('we_help_you')}</p>
                            </div>
                            <div className="car-image-contents bottom13">
                                <h4 className="light-black"> 3. {t('auction_upper')}</h4>
                                <p className="light-black">{t('your_car_will_listed')}</p>
                            </div>
                            <div className="car-image-contents bottom14">
                                <h4 className="light-black">4. {t('accept_bid')}</h4>
                                <p className="light-black">{t('once_satisfactory')}</p>
                            </div>
                            <div className="car-image-contents bottom15">
                                <h4 className="light-black">5. {t('inspection')}</h4>
                                <p className="light-black">{t('drive_your_car')}</p>
                            </div>
                            <div className="car-image-contents bottom16">
                                <h4 className="light-black">6. {t('pickup_payment')}</h4>
                                <p className="light-black">
                                    {t('pickup_payment_info')}
                                    <br />
                                    <br />
                                    {t('simplicity')}
                                    <br />
                                    <br />
                                    {t('you_donot_need')}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <CustomModal
                open={termsAndCondPopup}
                // handleClose={termsAndCondCancelClickHandler}
                modaltitle={t('terms')}
                disableBackdropClick
                footer={
                    <>
                        <PrimaryButton label={'Confirm'} onClick={termsAndCondAcceptClickHandler} />
                        {/* <SecondaryButton
                            label={'Cancel'}
                            onClick={termsAndCondCancelClickHandler}
                        /> */}
                    </>
                }
            >
                <div
                    className="terms"
                    dangerouslySetInnerHTML={{
                        __html: t('sellertermsandconditions'),
                    }}
                ></div>
            </CustomModal>
        </div>
    )
}

export default CarRegister
